module.exports = __webpack_public_path__ + "img/location.abbb5ace.svg";